import React from "react";
import SectionHeader from "@/components/SectionHeader";
import WorkCard from "@/components/WorkCard";

const TWEETS = [
  {
    index: "01",
    tag: "X · 73,600 views",
    title: "The Ranking Collapse That Nobody Saw Coming.",
    caption: "Motilal Oswal Flexi Cap went from #1 with 45.69% returns to #39 with -5.63% in one year. A before/after table is not easy to ignore.",
    image: "01 Twitter.jpg",
    link: "https://x.com/ETMONEY/status/2031384166710038868?s=20",
  },
  {
    index: "02",
    tag: "X · 96,800 views",
    title: "Two Legends, One Philosophy, Two Entirely Different Bets.",
    caption: "Rajeev Thakkar and Sankaran Naren manage nearly ₹2.35 lakh crore. Both are hardcore value investors. Their portfolios look nothing alike. Where are they finding value in the current market?",
    image: "02 Twitter.jpg",
    link: "https://x.com/ETMONEY/status/2029579218481545246?s=20",
  },
];

export default function PlatformNativePage() {
  return (
    <>
      <SectionHeader
        eyebrow="Case Study 06"
        pageIndex="06"
        title="Platform Native Strategies"
        kicker="Every platform has its own grammar. Distribution is not translation."
        lede="Most brands treat social as a distribution problem (post the same thing everywhere). Smart brands treat it as a translation problem: how does this idea live best on this platform? On Twitter, you're not competing for attention; you're competing for intellectual attention."
      />

      {/* Approach */}
      <section className="mx-auto max-w-[1440px] px-6 pt-20 lg:px-12">
        <div className="grid gap-px overflow-hidden border border-[#EDE4D3]/12 bg-[#EDE4D3]/10 md:grid-cols-3">
          {[
            ["Hook with intellect", "Open with strong insights or contrarian statements that experts have to engage with."],
            ["Visuals on a text-first feed", "The irony of high-design visuals on Twitter makes them stand out."],
            ["Speak the platform", "Short, punchy, provocative. Never clickbait."],
          ].map(([h, d]) => (
            <div key={h} className="bg-[#0B0E14] p-7">
              <p className="font-serif text-2xl text-[#D4A574]">{h}.</p>
              <p className="mt-3 text-sm text-[#EDE4D3]/65">{d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Examples */}
      <section className="mx-auto max-w-[1440px] px-6 pt-28 lg:px-12">
        <h2 className="mb-10 font-serif text-3xl tracking-tight lg:text-4xl">
          Threads that <span className="italic text-[#D4A574]">made experts click</span>.
        </h2>
        <div className="grid grid-cols-1 gap-x-8 gap-y-14 md:grid-cols-2">
          {TWEETS.map((t) => (
            <WorkCard key={t.index} {...t} ratio="4/3" />
          ))}
        </div>
      </section>

      {/* Insight */}
      <section className="mx-auto mt-32 max-w-[1000px] px-6 text-center lg:px-12">
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#D4A574]">The Insight</p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-[#EDE4D3]/85 md:text-3xl lg:text-4xl">
          Twitter users are <span className="text-[#D4A574]">active readers</span>, not passive scrollers. They want to think, debate, and form opinions. Give them something worth debating.
        </p>
      </section>
    </>
  );
}
